// React Router configuration
import { createBrowserRouter } from 'react-router-dom';

// Configure router without v7_startTransition to prevent double rendering
export const routerConfig = {
  future: {
    v7_relativeSplatPath: true
  }
};

// Use this function to create a router
export const createConfiguredRouter = (routes) => {
  return createBrowserRouter(routes, routerConfig);
};
